import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-modalities',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './modalities.component.html',
    styleUrls: ['./modalities.component.scss'],
    standalone: false
})
export class ModalitiesComponent {
  readonly FlatModels = FlatModels;

  constructor(public constantAuthorFacade: FlatFacades.ConstantAuthorFacade,
              public navigationControlFacade: FlatFacades.NavigationControlFacade) {
  }

  rowTrackBy(index: number,
             item: FlatModels.ModalityEntityModels.Modality) {
    return item.id || index;
  }

  onRowSelect($event: any) {
    this.navigationControlFacade.requestNavigate(['modality', $event.data]);
  }

  addNewModality() {
    this.navigationControlFacade.requestNavigate(['modality']);
  }
}
